import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { GridComponent } from '@progress/kendo-angular-grid';
import { ToastrService } from 'ngx-toastr';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { CommonDataModel } from '../common-data-model';
const hasClass = (el, className) => new RegExp(className).test(el.className);
const isChildOf = (el, className) => {
  while (el && el.parentElement) {
    if (hasClass(el.parentElement, className)) {
      return true;
    }
    el = el.parentElement;
  }
  return false;
};

@Component({
  selector: 'app-orders-floater-spacing',
  templateUrl: './orders-floater-spacing.component.html',
  styleUrls: ['./orders-floater-spacing.component.scss']
})
export class OrdersFloaterSpacingComponent extends AppComponentBase implements OnInit, OnChanges {

  // start declartion
  @Input() isExpanded: any;
  @Input() floaterDetails: any;
  @ViewChild('grid', { static: true }) private grid: GridComponent;
  @ViewChild('floaterSpacingForm', { static: false }) floaterSpacingForm: NgForm;
  @Output() emitEnableSaveButton: EventEmitter<any> = new EventEmitter();
  @Output() collapseEmit: EventEmitter<any> = new EventEmitter();
  commonDatModel = new CommonDataModel();
  gridItems: any = {
    data: [this.commonDatModel.floaterSpacingModel],
    total: 0
  };
  filters: any;
  statusValue = 'true';
  searchQuery: string;
  exportType: string;
  // end declartion

  // start constructor
  constructor(
    injector: Injector,
    private renderer: Renderer2,
    private toastr: ToastrService,
  ) {
    super(injector);
    this.renderer.listen(
      'document',
      'click',
      ({ target }) => {
        if (!isChildOf(target, 'floaterSpacingGrid')) {
          this.grid.closeRow(0);
          this.emitEnableSaveButton.emit();
        }
      });
  }
  // end constructor

  // start ngOnInit
  ngOnInit() {
  }
  // end ngOnInit

  ngOnChanges(changes: SimpleChanges) {
    if (changes.floaterDetails.currentValue) {
      this.gridItems.data[0] = changes.floaterDetails.currentValue;
    }
  }

  openAccordian(open: string, state: boolean) {
    if (open) {
      this.isExpanded = state;
      this.collapseEmit.emit();
    }
  }

  closeAccordian(open: string, state: boolean) {
    if (close) {
      this.isExpanded = state;
      this.collapseEmit.emit();
    }
  }

  onCellClickHandler({ sender, rowIndex }) {
    sender.editRow(rowIndex);
  }

  onAddSpacing() {
    this.updateSpacing(1);
    this.floaterSpacingForm.form.markAsDirty();
    this.emitEnableSaveButton.emit();
  }

  onSubtractSpacing() {
    if (this.gridItems.data[0].top > 1) {
      this.updateSpacing(-1);
      this.floaterSpacingForm.form.markAsDirty();
      this.emitEnableSaveButton.emit();
    } else {
      this.toastr.error(`Floater Spacing can't be less than 1`);
    }
  }

  updateSpacing(value: number) {
    if (this.gridItems.data && this.gridItems.data.length > 0) {
      // this.gridItems.data[0].bottom = (+this.gridItems.data[0].bottom) + value;
      this.gridItems.data[0].endOne = (+this.gridItems.data[0].endOne) + value;
      this.gridItems.data[0].endTwo = (+this.gridItems.data[0].endTwo) + value;
      this.gridItems.data[0].sideOne = (+this.gridItems.data[0].sideOne) + value;
      this.gridItems.data[0].sideTwo = (+this.gridItems.data[0].sideTwo) + value;
      this.gridItems.data[0].top = (+this.gridItems.data[0].top) + value;
    }
  }

}
